export default {
	terminology: {
		editAction: "Terminologie bearbeiten",
		searchFields: "Terminologiefelder suchen…",
		term: "Begriff",
		synonyms: "Synonyme",
		translationMissing: "Übersetzung fehlt",
		autosave: {
			saving: "Wird gespeichert…",
			saved: "Alle Änderungen gespeichert",
			error: "Speichern fehlgeschlagen — Verbindung prüfen",
		},
		generate: {
			field: "Generieren",
			regenerateField: "Neu generieren",
			missing: "Fehlende generieren",
			inProgress: "Terminologie wird generiert…",
			cancelling: "Wird abgebrochen…",
			done: "Terminologie für {count} Sprachen generiert",
			unavailable: "KI-Generierung ist auf diesem Server nicht konfiguriert.",
			empty: "Die KI hat kein brauchbares Ergebnis geliefert — versuchen Sie es erneut.",
			noChange: "Nichts Besseres gefunden — aktuelle Version beibehalten.",
		},
		translateLanguage: "Diese Sprache übersetzen",
		regenerateLanguage: "Diese Sprache neu generieren",
		verifyDescriptionFirst: "Zuerst eine Beschreibung als geprüft markieren",
		reviewSuggestionsFirst: "Zuerst die Vorschläge übernehmen oder verwerfen",
		descriptionGateHint:
			"Generieren Sie eine Beschreibung und markieren Sie sie als geprüft, um Begriffe, Synonyme und Übersetzungen freizuschalten.",
		markVerified: "Als geprüft markieren",
		verifiedBy: "Geprüft von {name} am {date}",
		acceptSuggestion: "Übernehmen",
		discardSuggestion: "Verwerfen",
		aiUnverified: "KI · ungeprüft",
		aiProvenance: "Von der KI, nicht geprüft",
		suggestedReplacement: "Vorgeschlagene Ersetzung",
		addSynonym: "„{term}“ hinzufügen",
		noSynonymOptions: "Synonym eintippen und hinzufügen",
		protectedSpanHint:
			"Text in [[doppelten Klammern]] wird nie übersetzt — das ganze Feld oder nur ein Teil davon.",
		dependencyLabel:
			"Diese Bezeichnung stammt aus „{alias}“. Eine Änderung speichert Ihre eigene Formulierung nur in diesem Projekt — „{alias}“ bleibt unverändert.",
		overrideLabel: "Sie haben für diesen Begriff aus „{alias}“ eine eigene Formulierung.",
		resetToDependency: "Auf Bezeichnung aus „{alias}“ zurücksetzen",
		verifyDependency:
			"Diese Bezeichnung stammt aus „{alias}“ und ist dort bereits geprüft. Ändern Sie sie zuerst, um Ihre eigene Formulierung als geprüft zu markieren.",
		dependencyNoLabel:
			"Dafür gibt es in „{alias}“ keine Bezeichnung zum Umbenennen, und aus diesem Projekt lässt sich keine anlegen.",
		panelTitle: "Terminologie:",
	},
};
